import { Component, OnInit } from '@angular/core';
import { ReqResService } from '../../service/req-res.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { AuthService } from '../../service/auth/auth.service'
import { map, first } from 'rxjs/operators';
import { AppLayoutComponent } from '../../layout/app-layout/app-layout.component';
import { Title } from '@angular/platform-browser';
declare var $: any;
declare var toastr: any;
@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.css']
})

export class AccountSettingsComponent implements OnInit {
  //variable
  userData: any = [];
  submitted = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImageData: any = '';
  showcroppedope: any = 0;
  imageSrc: string;
  errorImage: string;
  errorMessage: string;
  localStorageData: any = [];
  spinner: boolean = false;
  //
  constructor(private reqRes: ReqResService,
    private authService: AuthService
  , private titleService: Title) {
    this.titleService.setTitle('Account settings');}
  ngOnInit() {
    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });
    this.getUserData(1);
  }
  //user bind
  getUserData(type) {
    this.reqRes.getData('/Settings/GetUserData/' + type).subscribe(data => {
      this.userData = data[0];
      this.imageSrc = data[0].imgPath;
      if (this.userData != '') {
        this.invalidEmail = false;
      }
      this.spinner = false;
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }
  //fileUpload start
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    if (event.target.files[0].type.includes("image/")) {
      $("#modal_file").modal('show');
      this.errorImage = '';
    } else {
      this.errorImage = 'Please input valid image format '
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    console.log(event)
    this.croppedImage = event.base64;
  }

  SelectImage() {
    this.spinner = true;
    this.imageSrc = this.croppedImage;
    $("#modal_file").modal('hide');
    this.spinner = false;
  }

  //user post
  UserOperation(userDetails) {
    return this.reqRes.postData('/Settings/UserOperation', userDetails).pipe(map(response => {
      return response;
    }))
  };
  invalidEmail: boolean = true;
  checkInputValue(value) {
    var patt = new RegExp(/^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);
    this.invalidEmail = !patt.test(value);
  }

  onSubmit() {
    this.spinner = true;
    this.submitted = true;
    this.userData.ope = 1;
    this.userData.imgPath = (this.imageSrc.length > 300) ? this.imageSrc : this.authService.image();
    this.UserOperation(this.userData)
      .pipe(first())
      .subscribe(
        data => {
          let localStorage = data;
          this.spinner = false;
          this.authService.setUserData(localStorage);
          AppLayoutComponent._firstName = data[0].firstName;
          AppLayoutComponent._lastName = data[0].lastName;
          AppLayoutComponent._image = data[0].imgPath;
          toastr.success("Done!");
          this.getUserData(1);
        },
        err => {
          toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        },
        () => {
        });
  }
}


